import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { v4 } from 'uuid';

import { Dropdown } from 'UIPackage/MainModule/components/Dropdown';
import { IDropdownItem } from 'UIPackage/MainModule/interfaces/IDropdownItem';
import { KnmRegistryTypeEnum } from 'APIPackage/KnmModule/enums/KnmRegistryTypeEnum';
import { IKnmRegistryItem } from 'APIPackage/KnmModule/interfaces/IKnmRegistryItem';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { DropdownItem } from 'UIPackage/MainModule/components/DropdownItem';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';

import styles from './RegistryInfo.module.scss';
import { knmRegistryExport } from '../actions/knmRegistryActions';

interface IRegistryInfoProps {
  id: string;
  infoItems: IKnmRegistryItem[];
  registryName: string;
  registryType: keyof typeof KnmRegistryTypeEnum;
  exportRegistry: (id: string, registryType: keyof typeof KnmRegistryTypeEnum, format: ExportFormatsEnum) => void;
}

const RegistryInfoWithoutStore = ({
  id,
  infoItems,
  registryName,
  registryType,
  exportRegistry,
}: IRegistryInfoProps) => {
  const handleExport = (format: ExportFormatsEnum) => async () => {
    if (id) {
      exportRegistry(id, registryType, format);
    }
  };

  const dropdownItems: IDropdownItem[] = [
    {
      id: 'export-registry-pdf',
      content: <DropdownItem onClick={handleExport(ExportFormatsEnum.PDF)}>Экспорт в PDF</DropdownItem>,
    },
    {
      id: 'export-registry-ods',
      content: <DropdownItem onClick={handleExport(ExportFormatsEnum.ODS)}>Экспорт в ODS</DropdownItem>,
    },
    {
      id: 'export-registry-xlsx',
      content: <DropdownItem onClick={handleExport(ExportFormatsEnum.XLSX)}>Экспорт в XLSX</DropdownItem>,
    },
  ];

  return (
    <div className={styles.Page}>
      <div className={styles.Panel}>
        <div className={styles.Header}>{`Выписка из реестра ${registryName}`}</div>
        <Dropdown items={dropdownItems} />
      </div>
      <div className={styles.Table}>
        {infoItems.map(item => {
          const rowAttributes = {
            ...(item.title && { 'data-title': true }),
            ...(!item.title && { 'data-row': true }),
          };

          return (
            <div key={item.id ?? v4()} className={styles.Row} {...rowAttributes}>
              {item.title && item.key}
              {!item.title && <div className={styles.DataCounter}>{item.id}</div>}
              {!item.title && <div className={styles.DataText}>{item.key}</div>}
              {!item.title && <div className={styles.DataValue}>{item.value}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<RootActions>) => ({
  exportRegistry: (id: string, registryType: keyof typeof KnmRegistryTypeEnum, format: ExportFormatsEnum) =>
    dispatch(knmRegistryExport(id, registryType, format)),
});

export const RegistryInfo = connect(null, mapDispatchToProps)(RegistryInfoWithoutStore);
